var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 6,
    viewBox: "0 0 9 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.89661 0.998846C4.29001 0.590013 4.94436 0.590012 5.33776 0.998845L8.40039 4.18162C9.01172 4.81693 8.56148 5.875 7.67982 5.875H1.55456C0.672897 5.875 0.222659 4.81693 0.83398 4.18162L3.89661 0.998846Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonUp);
export default __webpack_public_path__ + "static/media/Polygon-up.ad313832fdd24276d055a1eba604591e.svg";
export { ForwardRef as ReactComponent };